import React, {useState, useEffect} from "react";
import { TextField, Checkbox, FormControlLabel, FormHelperText, Typography, Box, Container, Button, MenuItem, FormGroup, Grid, Radio, RadioGroup, FormLabel, FormControl, IconButton, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { useNavigate, Link as RouterLink, useLocation } from 'react-router-dom';
import { Delete, Add } from "@mui/icons-material";
import api from "./api.js";
import Header from "./components/Header.jsx";
import { useConfirmBackLogout } from "./common/useConfirmBackLogout.js";
import BackButton from './common/BackButton';
import { useNavigationHistory } from "./common/navigationHistory.js";
import { useValidatedDetailChangeByKey } from "./common/useValidatedDetailChangeByKey.js";
import { decimalValidator } from "./common/validators.js";
import HamburgerMenu from "./components/Hamburger.jsx";

const Comp11Sub = ({exhibitorId: propExhibitorId, isModal=false, isCorpModal=false, setFormModalOpen, selectedFormKey, changeModalOpen, setExhibitors}) => {
  const [exhibitorId, setExhibitorId] = useState(propExhibitorId || null);
  const [mypageData, setMypageData] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const [notApply, setNotApply] = useState(false);
  const [uploading, setUploading] = useState(false);
  const [previewFiles, setPreviewFiles] = useState([]);
  const createAlcoholDetail = () => ({
    alchol_name: '',
    alchol_quantity: '',
  });
  const createFireDetail = () => ({
    fire_device_name: '',
    fire_using: '',
  });
  const createGasDetail = () => ({
    gas_name: '',
    gas_category: '',
    gas_quantity: '',
    gas_number: '',
    gas_total: '',
  });
  const createOilDetail = () => ({
    oil_name: '',
    oil_quantity: '',
    oil_category: '',
  });
  const createOtherDetail = () => ({
    other_items: '',
    alfa_text: '',
  });
  const [checked, setChecked] = useState({
      flame: false,
      danger: false,
  });

  const handleScrollTo = (id, targetUrl) => {
      if (targetUrl && window.location.pathname !== targetUrl) {
        // 別ページなら localStorage に保存して navigate
        localStorage.setItem('scrollToId', id);
        navigate(targetUrl);
      } else {
        // 同ページなら即スクロール
        const el = document.getElementById(id);
        if (el) {
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };
  
  const [formData, setFormData] = useState({
    user_11_name: "",
    user_11_department: "",
    user_11_phone: "",
    user_11_tel: "",
    extinguisher: '',
    alfa_text: '',
    alchol_details: [createAlcoholDetail()],
    fire_details: [createFireDetail()],
    gas_details: [createGasDetail()],
    oil_details: [createOilDetail()],
    other_details: [createOtherDetail()],
    sds_pathes: [
        {
        safety_path: '',
        },
    ], 
  });

  const [errors, setErrors] = useState({});

  const handleValidatedDetailChange = useValidatedDetailChangeByKey(
    setFormData,
    setErrors
  );

  const [corrections, setCorrections] = useState({
    user_11_info: false,
    fire_details: false,
    oil_details: false,
    gas_details: false,
    alchol_details: false,
    other_details: false,
    sdss: false,
  });

  const field_name_map = {
    user_11_info: "担当者情報",
    fire_details: "裸火",
    oil_details: "石油",
    gas_details: "ガス",
    alchol_details: "アルコール類",
    other_details: "その他",
    sdss: "SDS・カタログなど",
  };

  const [memoText, setMemoText] = useState('');

  const handleCorrectionChange = (fieldKey) => (e) => {
    setCorrections(prev => ({
      ...prev,
      [fieldKey]: e.target.checked
    }));
  };

  const updateStatus = (exhibitorId, formType, updates) => {
    setExhibitors((prev) =>
      prev.map((ex) =>
        ex.exhibitor_id === exhibitorId
          ? {
              ...ex,
              ...Object.fromEntries(
                Object.entries(updates).map(([role, status]) => [
                  `${formType}_${role}_status`,
                  status,
                ])
              ),
            }
          : ex
      )
    );
  };

  const handleCorrection = async () => {
    try {
      const selectedFields = Object.entries(corrections)
        .filter(([_, checked]) => checked)
        .map(([field]) => field_name_map[field] || field);

      if (selectedFields.length === 0) {
        alert('修正対象の項目を選択してください');
        return;
      }

      const currentPath = window.location.pathname;

      await api.patch('/api/host-correction', {
        exhibitor_id: exhibitorId,
        form_type: 'o11',
        correction: selectedFields,
        memo: memoText,
        current_path: currentPath,
      });

      // 👇 これ追加
      updateStatus(exhibitorId, 'o11', {
        host: '未確認',
        corporate: '未確認',
      });

      alert('修正リクエスト送信完了');
      setFormModalOpen(false);

      setCorrections(
        Object.fromEntries(Object.keys(corrections).map(k => [k, false]))
      );
      setMemoText('');

    } catch (err) {
      console.error(err);
      alert('修正処理でエラーが発生しました');
    }
  };

  const updateHostStatus = (exhibitorId, formType, newStatus) => {
    setExhibitors((prev) =>
      prev.map((ex) =>
        ex.exhibitor_id === exhibitorId
          ? {
              ...ex,
              [`${formType}_host_status`]: newStatus,
              [`${formType}_corporate_status`]: newStatus, // ←これ追加
            }
          : ex
      )
    );
  };

    // 確認済み
    const handleConfirm = async () => {
    try {
      const res = await api.patch('/api/forms/confirm', {
        exhibitor_id: exhibitorId,
        form_type: selectedFormKey,
        role: "host"
      });
      
      updateHostStatus(exhibitorId, selectedFormKey,'確認済');

      alert('確認済みに更新しました');
      setFormModalOpen(false);
    } catch (err) {
      console.error(err);
      alert('確認処理でエラー');
    }

    console.log('送信データ', {
      exhibitor_id: exhibitorId,
      form_type: selectedFormKey,
      role: "host"
    });
  };

  useEffect(() => {
    if ((isModal || isCorpModal) && propExhibitorId) {
      setExhibitorId(propExhibitorId);
      return;
    }

    const userData = localStorage.getItem("user");

    if (userData) {
      const parsedUser = JSON.parse(userData);
      if (parsedUser?.exhibitor_id) {
        setExhibitorId(parsedUser.exhibitor_id);
      } else {
        console.warn("exhibitor_id が見つかりません");
      }
    } else {
      console.warn("localStorageにuserが存在しません");
    }
  }, [location, isModal, isCorpModal, propExhibitorId]);


  const [sameAsExhibitor, setSameAsExhibitor] = useState("different");  

  const handleChange = (field) => (e) => {
    const value = e.target.type === "checkbox" ? e.target.checked : e.target.value;
    setFormData((prev) => ({ ...prev, [field]: value }));
  };

  const [formErrors, setFormErrors] = useState({}); // フィールドごとのエラーを保持

  // 半角整数チェック関数
  const isInteger = (val) => /^[0-9]+$/.test(val);

  const handleArrayChange = (key, index, field, value) => {
    const updated = [...formData[key]];
    let errorMsg = "";

    // 数値フィールドのときだけ整数チェック
    if (["alchol_quantity", "oil_quantity", "gas_quantity"].includes(field)) {
      if (value === "" || isInteger(value)) {
        // OK → 数値化（空文字は空のまま）
        updated[index][field] = value === "" ? "" : Number(value);
      } else {
        // NG → 値はそのまま保持してエラーメッセージ
        updated[index][field] = value;
        errorMsg = "半角数字（整数）のみ入力してください";
      }
    } else {
      // 文字列系フィールドはそのまま
      updated[index][field] = value;
    }

    setFormData({ ...formData, [key]: updated });

    // エラーを更新
    setFormErrors((prev) => {
      const newErrors = { ...prev };
      if (errorMsg) {
        newErrors[`${key}_${index}_${field}`] = errorMsg;
      } else {
        delete newErrors[`${key}_${index}_${field}`];
      }
      return newErrors;
    });
  };

  const handleAdd = (key, initial = {}) => {
    setFormData({ ...formData, [key]: [...formData[key], initial] });
  };

  const handleDelete = (key, index) => {
    const updated = [...formData[key]];
    updated.splice(index, 1);
    setFormData({ ...formData, [key]: updated });
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const user = JSON.parse(localStorage.getItem('user'));
        const res = await api.get(`/api/mypage/${exhibitorId}`);
        setMypageData(res.data);
      } catch (err) {
        console.error("データ取得エラー:", err);
      }
    };
    fetchData();
  }, []);

  const [fieldsDisabled, setFieldsDisabled] = useState(false);

  const handleSameAsExhibitor = (value) => {
    setSameAsExhibitor(value);

    if (value === "same") {
      // 出展者情報コピー
      setFormData((prev) => ({
        ...prev,
        user_11_name: mypageData.user_name || "",
        user_11_department: mypageData.department || "",
        user_11_phone: mypageData.phone_number || "",
        user_11_tel: mypageData.tel_number || "",
      }));
      setFieldsDisabled(true);
    } else if (value === "different") {
      // フィールドを空にする
      setFormData((prev) => ({
        ...prev,
        user_11_name: "",
        user_11_department: "",
        user_11_phone: "",
        user_11_tel: "",
      }));
      setFieldsDisabled(false);
    }
  };

  useEffect(() => {
    const fetchO11InitialData = async () => {
        try {
        const user = JSON.parse(localStorage.getItem("user"));

        const [resStatus, resO11, resMypage] = await Promise.all([
            api.get(`/api/submission-status/${exhibitorId}`),
            api.get(`/api/o11submission/${exhibitorId}`),
            api.get(`/api/mypage/${exhibitorId}`)
        ]);

        const o11Status = resStatus.data?.o11_status || "";
        const o11Data = resO11.data || {};
        const mypage = resMypage.data || {};

        if (o11Status === "申請しない") {
            setNotApply(true);
            setFormData({
            user_11_name: null,
            user_11_department: null,
            user_11_phone: null,
            user_11_tel: null,
            extinguisher: null,
            alfa_text: null,
            alchol_details: [createAlcoholDetail()],
            fire_details: [createFireDetail()],
            gas_details: [createGasDetail()],
            oil_details: [createOilDetail()],
            other_details: [createOtherDetail()],
            sds_pathes: [],
            });
        } else {
            if (Object.values(o11Data).some(v => {
            if (Array.isArray(v)) return v.length > 0;
            return v !== "" && v !== null && v !== undefined;
            })) {
            setFormData(prev => ({
                ...prev,
                ...o11Data,
                alchol_details: o11Data.alchol_details?.length ? o11Data.alchol_details : [createAlcoholDetail()],
                fire_details: o11Data.fire_details?.length ? o11Data.fire_details : [createFireDetail()],
                gas_details: o11Data.gas_details?.length ? o11Data.gas_details : [createGasDetail()],
                oil_details: o11Data.oil_details?.length ? o11Data.oil_details : [createOilDetail()],
                other_details: o11Data.other_details?.length ? o11Data.other_details : [createOtherDetail()],
                sds_pathes: o11Data.sds_pathes || [],
            }));
            if (
              o11Data.user_11_name === mypage.user_name &&
              o11Data.user_11_department === mypage.department &&
              o11Data.user_11_phone === mypage.phone_number &&
              o11Data.user_11_tel === mypage.tel_number
            ) {
              setSameAsExhibitor("same");
              setFieldsDisabled(true);
            } else {
              setFieldsDisabled(false);
            }
            }

            setNotApply(false);
        }

        } catch (err) {
        console.error("O11初期データ取得エラー:", err);
        }
    };

    fetchO11InitialData();
    }, []);

  useEffect(() => {
    const fetchPreviewUrls = async () => {
      const previews = await Promise.all(
        formData.sds_pathes.map(async (file) => {
          if (!file?.safety_path) return file;

          const parts = file.safety_path.split("/").filter(Boolean);
          const exhibitorId = parts[1];
          const filename = parts[parts.length - 1];

          if (!exhibitorId || isNaN(Number(exhibitorId))) {
            console.warn("不正な safety_path:", file.safety_path);
            return { ...file, previewUrl: null };
          }

          try {
            const res = await api.get(
              `/api/files/o11/${exhibitorId}/${filename}?t=${Date.now()}`,
              { responseType: "blob" }
            );

            const url = URL.createObjectURL(res.data);
            return {
              ...file,
              previewUrl: url,
              mimeType: res.data.type,
              name: filename,
            };
          } catch (err) {
            console.error("ファイル取得失敗:", err);
            return { ...file, previewUrl: null };
          }
        })
      );

      setPreviewFiles(previews);
    };

    if (!formData.sds_pathes?.length) {
      setPreviewFiles([]);
      return;
    }

    fetchPreviewUrls();
  }, [formData.sds_pathes]);


  const handleNoApplyChange = (checked) => {
      setNotApply(checked);

      if (checked) {
          setFormData({
            user_11_name: "",
            user_11_department: "",
            user_11_phone: "",
            user_11_tel: "",
            extinguisher: null,
            alfa_text: null,
            alchol_details: [createAlcoholDetail()],
            fire_details: [createFireDetail()],
            gas_details: [createGasDetail()],
            oil_details: [createOilDetail()],
            other_details: [createOtherDetail()], 
            sds_pathes: [], 
          });
      }
  };
  
    const [isHovered, setIsHovered] = useState(false);
  
    const pdfItems = [
      // { label: 'INDEX', path: '/INDEX.pdf' },
      { label: '出展規定', path: '/出展規定.pdf' },
      { label: '出展者申請システム 操作マニュアル', path: '/出展者申請システム_操作マニュアル.pdf' },
      { label: '色見本', path: '/色見本.pdf' },
      { label: '運送関係のご案内', path: '/運送関係のご案内（ヤマト運輸）.pdf' },
      { label: '宿泊関係のご案内', path: '/宿泊関係のご案内.zip' },
      { label: '飲食関係のご案内', path: '/飲食関係のご案内.zip' },
      { label: '緊急災害時におけるご案内', path: '/緊急災害時におけるご案内.pdf' },
      { label: '出展者用追加パス', path: '/出展者用追加パス.pdf' },
      { label: '小間図面', path: '/小間図面.pdf' },
      { label: '素材集', path: '/素材集.zip' },
      // { label: '出展者駐車許可証(見本)', path: '/出展者駐車場入構許可証兼搬出車両一時停車許可証見本.pdf' },
      // { label: '当日スタッフ', path: '/当日スタッフ.pdf' },
      // { label: '公式アプリ・出展者PR', path: '/公式アプリ・出展者15秒PR.pdf' },
      // { label: '第1展示館の小間図面', path: '/第1展示館の小間図面.pdf' },
      // { label: '出展者一覧', path: '/出展者一覧.pdf' },
      // { label: '出展者へのお願い', path: '/出展者へのお願い.pdf' },
      // { label: '運送関連', path: '/運送関連.zip' },
      // { label: 'グルメッセキッチンカー', path: '/グルメッセキッチンカーについて.pdf' },
      // { label: '出展者操作マニュアル', path: '/出展者操作マニュアル.pdf' },
    ];
  
    const renderMenuItems = () => (
      <div
          className="menu-item"
          onMouseEnter={() => setIsHovered(true)}
          onMouseLeave={() => setIsHovered(false)}
      >
          <div className="menu-label">資料ダウンロード</div>
          {isHovered && (
          <div className="submenu">
              {pdfItems.map((item, index) => (
              <a key={index} href={item.path} download className="submenu-item">
                  {item.label}
              </a>
              ))}
          </div>
          )}
      </div>
    );

    const handleGasChange = (key, index, field, value) => {
      const updatedGasDetails = [...formData.gas_details];
      updatedGasDetails[index][field] = value;

      // 数値判定（半角数字のみ許可、小数点はNG）
      const quantityNum = parseInt(updatedGasDetails[index].gas_quantity, 10);
      const numberNum = parseInt(updatedGasDetails[index].gas_number, 10);

      // formErrors の更新
      const newFormErrors = { ...formErrors };
      if (field === "gas_quantity") {
        if (value && !/^\d*$/.test(value)) {
          newFormErrors[`gas_details_${index}_gas_quantity`] = "半角数字で入力してください";
        } else {
          delete newFormErrors[`gas_details_${index}_gas_quantity`];
        }
      }
      if (field === "gas_number") {
        if (value && !/^\d*$/.test(value)) {
          newFormErrors[`gas_details_${index}_gas_number`] = "半角数字で入力してください";
        } else {
          delete newFormErrors[`gas_details_${index}_gas_number`];
        }
      }

      // 計算（不足は 0 と扱う）
      const total = (isNaN(quantityNum) ? 0 : quantityNum) * (isNaN(numberNum) ? 0 : numberNum);
      updatedGasDetails[index].gas_total = total;

      // デバッグ（開発時のみ）
      console.log("handleGasChange:", { index, field, value, quantityNum, numberNum, total });

      setFormData((prev) => ({
        ...prev,
        gas_details: updatedGasDetails,
      }));
      setFormErrors(newFormErrors);
    };

    const handleSubmitEx = async () => {
        try {
            if (!exhibitorId || typeof exhibitorId !== "number") {
            alert("exhibitorId が不正です");
            return;
            }

            const confirmedData = {
              user_11_name: formData.user_11_name,
              user_11_department: formData.user_11_department,
              user_11_phone: formData.user_11_phone,
              user_11_tel: formData.user_11_tel,
              alfa_text: formData.alfa_text,
              alchol_details: [],
              fire_details: [],
              gas_details: [],
              oil_details: [],
              other_details: [],
            };

            const payload = {
                exhibitor_id: exhibitorId,
                formData: confirmedData,
                notApply: notApply,
            };

            const res = await api.post("/api/submit-o11-ex", payload);

            if (res.status === 200) {
        alert("詳細確認中として保存しました");
      } else {
        alert("保存失敗");
      }
      setTimeout(() => {
        if (isModal) {
          setFormModalOpen(false);
        } else {
          navigate(`/mypage/${user?.mypage_id}`);
        }
      }, 1000);
        } catch (err) {
            console.error(err);
            alert("エラー");
        }
    };

    const [noticeModalOpen, setNoticeModalOpen] = useState(false);
    const [ submitErrors, setSubmitErrors] = useState({});

  const handleSubmit = async () => {
    try {
      if (!exhibitorId || typeof exhibitorId !== "number") {
        alert("exhibitorId が不正です");
        return;
      }

      const sanitizeFormData = (data) => {
        if (Array.isArray(data)) {
          return data.map(sanitizeFormData);
        } else if (typeof data === "object" && data !== null) {
          const newObj = {};
          for (const [key, value] of Object.entries(data)) {
            if (value === "") {
              newObj[key] = null;
            }
            // --- 数値フィールド ---
            else if (
              [
                "alchol_quantity",
                "gas_quantity",
                "gas_number",
                "gas_total",
                "oil_quantity",
                "category",
              ].includes(key)
            ) {
              newObj[key] =
                value !== null && value !== "" && !isNaN(Number(value))
                  ? Number(value)
                  : null;
            }
            // --- 文字列フィールド ---
            else if (
              [
                "alchol_name",
                "fire_device_name",
                "fire_using",
                "gas_name",
                "gas_category",
                "oil_name",
                "oil_category",
                "other_items",
                "safety_path",
                "alfa_text",
                "user_11_name",
                "user_11_department",
                "user_11_phone",
                "user_11_tel",
              ].includes(key)
            ) {
              newObj[key] = value != null ? String(value) : null;
            }
            // --- 再帰 ---
            else {
              newObj[key] = sanitizeFormData(value);
            }
          }
          return newObj;
        }
        return data;
      };

      const normalizedFormData = {
        ...formData,
        alchol_details: (formData.alchol_details || []).filter(
          (item) => item?.alchol_name?.trim() || item?.alchol_quantity !== ""
        ),
        fire_details: (formData.fire_details || []).filter(
          (item) => item?.fire_device_name?.trim() || item?.fire_using?.trim()
        ),
        gas_details: (formData.gas_details || []).filter(
          (item) =>
            item?.gas_name?.trim() ||
            item?.gas_category?.trim() ||
            item?.gas_quantity !== "" ||
            item?.gas_number !== ""
        ),
        oil_details: (formData.oil_details || []).filter(
          (item) =>
            item?.oil_name?.trim() ||
            item?.oil_category?.trim() ||
            item?.oil_quantity !== ""
        ),
        other_details: (formData.other_details || []).filter(
          (item) => item?.other_items?.trim() || item?.alfa_text?.trim()
        ),
      };
      const sanitizedFormData = sanitizeFormData(normalizedFormData);

      const submitErrors = {};

      if (!notApply) {
        // 基本必須項目チェック
        if (!formData.user_11_name?.trim())
          submitErrors.user_11_name = "入力してください";
        if (!formData.user_11_phone?.trim())
          submitErrors.user_11_phone = "入力してください";
        if (!formData.user_11_tel?.trim())
          submitErrors.user_11_tel = "入力してください";
        if (
          !normalizedFormData.alchol_details.length &&
          !normalizedFormData.fire_details.length &&
          !normalizedFormData.gas_details.length &&
          !normalizedFormData.oil_details.length &&
          !normalizedFormData.other_details.length
        ) {
          submitErrors.danger_items = "危険物品を1件以上入力してください";
        }
      }

      const fieldDisplayNames = {
        user_11_name: "担当者名",
        user_11_department: "担当部署",
        user_11_phone: "担当者携帯",
        user_11_tel: "担当者電話",
        danger_items: "危険物品",
      };

      if (Object.keys(submitErrors).length > 0) {
        setSubmitErrors(submitErrors);
        window.scrollTo({ top: 0, behavior: "smooth" });

        const errorMessages = Object.entries(submitErrors)
          .map(
            ([key, msg]) => `・${fieldDisplayNames[key] || key}：${msg}`
          )
          .join("\n");

        alert(`提出エラー：未入力の項目があります\n${errorMessages}`);
        return;
      }

      const payload = {
        exhibitor_id: exhibitorId,
        formData: sanitizedFormData,
        notApply: notApply,
      };

      console.log(payload)

      const res = await api.post("/api/submit-o11", payload);

      if (res.status === 200) {
        if (!notApply){
        setNoticeModalOpen(true);
        }
        alert("保存成功");
      } else {
        alert("保存失敗");
      }
    } catch (err) {
      console.error(err);
      alert("エラー");
    }
  };


  const handleCloseNotice = () => {
    const user = JSON.parse(localStorage.getItem("user"));
    setNoticeModalOpen(false);
    setTimeout(() => {
      if (isModal) {
        setFormModalOpen(false);
      } else {
        if (user?.user_id === 0) {
          navigate(`/co-exhibit-mypage/${user?.mypage_id}`);
        } else {
          navigate(`/mypage/${user?.mypage_id}`);
        }
      }
    }, 1000);
  };
  const user = JSON.parse(localStorage.getItem("user"));
  useConfirmBackLogout(navigate);
  useNavigationHistory();

  console.log(formData)

  const handleFileChange = async (e) => {
      const files = Array.from(e.target.files);
      if (!files.length) return;

      setUploading(true);

      const formDataObj = new FormData();
      files.forEach((file) => {
        formDataObj.append("files", file);
      });

      try {
        const res = await api.post(`/api/upload-sds/${exhibitorId}`, formDataObj, {
          headers: { "Content-Type": "multipart/form-data" },
        });

        const newPaths = res.data.paths.map((path) => ({ safety_path: path }));

        // アップロード後にプレビュー画像を取得
        const newPreviews = await Promise.all(
          res.data.paths.map(async (path) => {
            const exhibitorId = path.split("/")[1]; // 例: "1"
            const filename = path.split("/").pop(); // 例: "5.jpg"

            try {
              const res = await api.get(`/api/files/o11/${exhibitorId}/${filename}?t=${Date.now()}`, {
                responseType: "blob",
              });

              const url = URL.createObjectURL(res.data);
              return {
                safety_path: path,
                previewUrl: url,
                mimeType: res.data.type,
                name: filename,
              };
            } catch (err) {
              console.error("ファイル取得失敗:", err);
              return {
                safety_path: path,
                previewUrl: null,
                mimeType: null,
                name: null,
              };
            }
          })
        );

        // sds_pathes と previewFiles を更新
        setFormData((prev) => ({
          ...prev,
          sds_pathes: [...prev.sds_pathes, ...newPaths],
        }));

        setPreviewFiles((prev) => [...prev, ...newPreviews]);
      } catch (err) {
        console.error("アップロード失敗", err);
        alert("アップロードに失敗しました。");
      } finally {
        setUploading(false);
        e.target.value = null;
      }
    };

  const handleDeleteFile = async (indexToDelete) => {
    const pathToDelete = formData.sds_pathes[indexToDelete].safety_path;
    try {
      await api.delete("/api/delete-sds", { data: { path: pathToDelete } });

      // formData.sds_pathes のみ更新（これをトリガーに useEffect で previewFiles が更新される）
      setFormData((prev) => ({
        ...prev,
        sds_pathes: prev.sds_pathes.filter((_, idx) => idx !== indexToDelete),
      }));
    } catch (err) {
      console.error("削除失敗", err);
      alert("削除に失敗しました。");
    }
  };

  const baseUrl =
  window.location.hostname === 'localhost'
    ? 'http://127.0.0.1:8000'          // ローカル開発用
    : 'https://sdgs.ex-link.net'; // 本番 HTTPS
  return (
    <div>
      {!isCorpModal &&(
        <Header
          title="SDGs 子ども・ユースフェア2026 危険物品申請"
          companyName={mypageData?.company_name}
        />
      )}
      <style>
        {`
        @media only screen and (max-width: 560px) {
        .sm-block {display: block;}
        .sm-none {display: none;}
        .sm-column {flex-direction: column;}
        .noti-cate {font-size: 18px;}
        .timestamp {font-size: 14px;}
        .info {font-size: 14px;}
        .f-16 {font-size: 16px;}
        .flex-wrap-sm {flex-wrap: wrap;}
        }
        @media only screen and (min-width: 561px) {
        .hamburger_menu_btn_wrap {display: none;}
        }
        `}
       </style>
       <Container sx={{ display: 'flex' }}>
        {!isCorpModal &&(
        <>
        <Container sx={{ width: '22%', mt: 4 }} className="sm-none">
          <Box>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
              <Box
               className={`menu-item`}
               onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`${user?.mypage_url}`);
                }}
              >
                TOP
              </Box>
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user'));
                  navigate(`/mypage-info/${user?.exhibitor_id}`);
                }}
              >
                出展者情報編集
              </Box>
              {/* <Box
                className="menu-group"
                id="hover-block"
                onMouseEnter={() => {}}
                onMouseLeave={() => {}}
              >
                <Box className="menu-item reverse-triangle" onClick={() => setShowFormMenu(prev => !prev)}>
                  申請フォーム
                </Box>
                  {showFormMenu && (
                    <Box className="hover-menu">
                      <Typography
                        sx={{ color: '#FF0000', textAlign: 'center',borderBottom: '1px solid #00111BC', pb: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-require')}
                      >
                        必須フォーム<br />
                        (全出展者対象)
                      </Typography>
                      <Typography
                        sx={{ color: '#00111bc', textAlign: 'center', pt: 1 }}
                        className='form-button'
                        onClick={() => navigate('/form-optional')}
                      >
                        任意フォーム<br />
                        (該当出展者対象)
                      </Typography>
                    </Box>
                  )}
              </Box> */}
              <Box 
                className="menu-item"
                onClick={() => {
                  navigate('/mail-form/');
                }}
              >
                お問い合わせ
              </Box>
              {renderMenuItems()}
              <Box 
                className="menu-item"
                onClick={() => {
                  const user = JSON.parse(localStorage.getItem('user') || '{}');
                  const mypage = user?.mypage_url;

                  handleScrollTo('news', mypage);
                }}
              >
                お知らせ
              </Box>
              <Box
                className="menu-item"
                onClick={() => window.open('https://sdgs-aichi.com/privacy/index.html', '_blank', 'noopener,noreferrer')}
              >
                個人情報保護方針
              </Box>
            </Box>
          </Box>
          <BackButton />
        </Container>
        <HamburgerMenu />
        </>
        )}
        {!!changeModalOpen &&(
          <Box sx={{ width: '30%', p: 3, borderRight: '1px solid #ccc', bgcolor: '#f5f5f5', maxWidth: '40%' }}>
            <Typography variant="h6" gutterBottom>
              修正内容のメモ
            </Typography>
            <TextField
              multiline
              rows={20}
              fullWidth
              placeholder="ここに修正内容を書いてください..."
              value={memoText}
              onChange={(e) => setMemoText(e.target.value)}
            />
            <Box>
              <Typography variant="h6">マイページ情報</Typography>
              {mypageData ? (
                <Box sx={{ mt: 2, p: 2, border: '1px solid #ccc', borderRadius: 2 }}>
                  <Typography variant="body1">小間番号: {mypageData.booth_number}</Typography>
                  <Typography variant="body1">出展者名: {mypageData.company_name}</Typography>
                  <Typography variant="body1">部署: {mypageData.department}</Typography>
                  <Typography variant="body1">担当者名: {mypageData.user_name}</Typography>
                  <Typography variant="body1">郵便番号: {mypageData.zip_code}</Typography>
                  <Typography variant="body1">住所: {mypageData.address}</Typography>
                  <Typography variant="body1">電話番号: {mypageData.phone_number}</Typography>
                  <Typography variant="body1">メールアドレス: {mypageData.email}</Typography>
                </Box>
              ) : (
                <Typography variant="body2">読み込み中...</Typography>
              )}
            </Box>
          </Box>
        )}
        <Container sx={{width: {xs:'100%',md: '80%'}, mt:4, pb:'30px'}}>
        <Typography variant="h6">危険物品（石油・ガス・裸火等）の許可申込</Typography>
        <Container sx={{ p: 2, border: "1px solid #ccc", borderRadius: 2 }}>
            <FormControlLabel
            control={<Checkbox checked={notApply} onChange={(e) => handleNoApplyChange(e.target.checked)} />}
            label="申請しない"
            />

            {!notApply && (
            <>
            <Box sx={{ display: "flex", flexDirection: "column", gap: 2, mt: 2 }}>
                {!!changeModalOpen &&(
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={corrections.user_11_info}
                        onChange={handleCorrectionChange( 'user_11_info')}
                        sx={{
                    color: 'red', // 未チェック時の枠の色
                    '&.Mui-checked': {
                      color: 'red', // チェック時の色
                    },
                  }}
                      />
                    }
                    label="担当者情報"
                  />
                )}
                <Typography variant="h6" gutterBottom>
                担当者情報
                </Typography>
                <Typography color="error">※担当者は搬入出時等で現場対応いただける方をご入力ください。</Typography>
                <FormControl component="fieldset">
                <FormLabel component="legend">出展申込時の担当者と</FormLabel>
                <RadioGroup row value={sameAsExhibitor} onChange={(e) => handleSameAsExhibitor(e.target.value)}>
                    <FormControlLabel value="same" control={<Radio />} label="同じ" />
                    <FormControlLabel value="different" control={<Radio />} label="異なる" />
                </RadioGroup>
                </FormControl>
                <Grid container spacing={2}>
                <Grid size={6}><TextField fullWidth label="氏名" name="user_11_name" value={formData.user_11_name} disabled={fieldsDisabled} onChange={handleChange("user_11_name")} error={!!submitErrors.user_11_name} helperText={submitErrors.user_11_name} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="部署" name="user_11_department" value={formData.user_11_department} disabled={fieldsDisabled} onChange={handleChange("user_11_department")} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="会社電話番号" name="user_11_phone" value={formData.user_11_phone} disabled={fieldsDisabled} onChange={handleChange("user_11_phone")} error={!!submitErrors.user_11_phone} helperText={submitErrors.user_11_phone} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                <Grid size={6}><TextField fullWidth label="携帯電話番号" name="user_11_tel" value={formData.user_11_tel} disabled={fieldsDisabled} onChange={handleChange("user_11_tel")} error={!!submitErrors.user_11_tel} helperText={submitErrors.user_11_tel} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/></Grid>
                </Grid>
                <Typography color="error">※搬入・搬出時にご連絡可能な電話番号をご入力ください。</Typography>
             
                <Box>
                {/* <FormControl
                  required
                  error={!!submitErrors.flame}   // エラー状態をここで反映
                  component="fieldset"
                  variant="standard"
                >
                  <FormGroup row>
                      <FormControlLabel
                      control={<Checkbox name="flame" checked={checked.flame} onChange={handleCheckboxChange} />}
                      label="防炎対象物品の持込有り"
                      />
                      <FormControlLabel
                      control={<Checkbox name="danger" checked={checked.danger} onChange={handleCheckboxChange} />}
                      label="危険物の持込有り"
                      />
                  </FormGroup>
                  <FormHelperText>
                    {submitErrors.flame || submitErrors.danger}
                  </FormHelperText>
                </FormControl> */}
                {/* {checked.flame && (
                <>
                {!!changeModalOpen &&(
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={corrections.flame_details}
                        onChange={handleCorrectionChange( 'flame_details')}
                        sx={{
                    color: 'red', // 未チェック時の枠の色
                    '&.Mui-checked': {
                      color: 'red', // チェック時の色
                    },
                  }}
                      />
                    }
                    label="防炎対象物"
                  />
                )}
                <Typography variant="h6" gutterBottom>防炎対象物品</Typography>

                {formData.flame_details.map((item, index) => (
                    <Box key={index} display="flex" alignItems="center" gap={1} mb={1}>
                    <TextField label="物品名" value={item.fire_items} onChange={(e) => handleArrayChange("flame_details", index, "fire_items", e.target.value)} error={!!submitErrors[`flame_details_${index}`]} helperText={submitErrors[`flame_details_${index}`]} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/>
                    <TextField label="登録番号" value={item.flame_retardant_id} onChange={(e) => handleArrayChange("flame_details", index, "flame_retardant_id", e.target.value)} error={!!submitErrors[`flame_details_${index}`]} helperText={submitErrors[`flame_details_${index}`]} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/>
                    <IconButton onClick={() => handleDelete("flame_details", index)}><Delete /></IconButton>
                    </Box>
                ))}
                <Button onClick={() => handleAdd("flame_details", { fire_items: "", flame_retardant_id: "" })} startIcon={<Add />}>追加</Button>
                </>
                )} */}

                {/* {checked.danger && (
                <> */}
                <Typography variant="h6" gutterBottom>危険物品</Typography>
                {!!changeModalOpen &&(
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={corrections.alchol_details}
                        onChange={handleCorrectionChange( 'alchol_details')}
                        sx={{
                    color: 'red', // 未チェック時の枠の色
                    '&.Mui-checked': {
                      color: 'red', // チェック時の色
                    },
                  }}
                      />
                    }
                    label="アルコール類情報"
                  />
                )}
                <Typography variant="subtitle2" gutterBottom>アルコール類</Typography>
                <Typography color="error">※手指消毒用以外で濃度60%以上のアルコールを持ち込む場合に入力してください。</Typography>
                {formData.alchol_details.map((item, index) => {
                  const showError = !!submitErrors[`alchol_details_${index}`] || (!!submitErrors.checked_danger && !formData.alchol_details.some(i => i.alchol_name?.trim() && i.alchol_quantity?.trim()));
                    return (
                      <Box key={index} display="flex" alignItems="center" gap={1} mb={1}>
                      <TextField label="品名" value={item.alchol_name} onChange={(e) => handleArrayChange("alchol_details", index, "alchol_name", e.target.value)} error={showError} helperText={showError ? submitErrors[`alchol_details_${index}`] || submitErrors.checked_danger : ""} />
                      <TextField
                        label="量(L)"
                        value={item.alchol_quantity}
                        onChange={handleValidatedDetailChange(
                          "alchol_details",
                          index,
                          "alchol_quantity",
                          decimalValidator({ scale: 2, label: "量(L)" })
                        )}
                        error={
                          !!errors?.alchol_details?.[index]?.alchol_quantity ||
                          !!submitErrors[`alchol_details_${index}`] ||
                          !!submitErrors.checked_danger
                        }
                        helperText={
                          errors?.alchol_details?.[index]?.alchol_quantity ||
                          submitErrors[`alchol_details_${index}`] ||
                          submitErrors.checked_danger ||
                          ""
                        }
                        onWheel={(e) => e.target.blur()}
                      />
                      {formData.alchol_details.length >= 1 && (
                        <IconButton
                          onClick={() => handleDelete("alchol_details", index)}
                        >
                          <Delete />
                        </IconButton>
                      )}
                      </Box>
                    )
                })}
                <Button onClick={() => handleAdd("alchol_details", { alchol_name: "", alchol_quantity: "" })} startIcon={<Add />}>追加</Button>
                {!!changeModalOpen &&(
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={corrections.oil_details}
                        onChange={handleCorrectionChange( 'oil_details')}
                        sx={{
                    color: 'red', // 未チェック時の枠の色
                    '&.Mui-checked': {
                      color: 'red', // チェック時の色
                    },
                  }}
                      />
                    }
                    label="石油類情報"
                  />
                )}
                <Typography variant="subtitle2" gutterBottom>石油類</Typography>
                {formData.oil_details.map((item, index) => {
                  const showError =
                  !!submitErrors[`oil_details_${index}`] ||
                  (!!submitErrors.checked_danger &&
                    !formData.oil_details.some(
                      i => i.oil_category?.trim() && i.oil_name?.trim() && i.oil_quantity?.trim()
                    )
                  );
                  return (
                    <Box key={index} display="flex" alignItems="center" gap={1} mb={1} className="flex-wrap-sm">
                    <TextField select label="カテゴリ" value={item.oil_category} onChange={(e) => handleArrayChange("oil_details", index, "oil_category", e.target.value)} sx={{ width: {xs:'100%',md: '20%'} }} error={showError} helperText={showError ? submitErrors[`oil_details_${index}`] || submitErrors.checked_danger : ""}>
                        <MenuItem value="第1石油類">第1石油類(ガソリン・ベンジン・塗顔料など)</MenuItem>
                        <MenuItem value="第2石油類">第2石油類(灯油・軽油・テレピン油など)</MenuItem>
                        <MenuItem value="第3石油類">第3石油類(重油・マシン油・潤滑油など)</MenuItem>
                        <MenuItem value="第4石油類">第4石油類(ギヤー油・シリンダー油など)</MenuItem>
                    </TextField>
                    <TextField label="品名" value={item.oil_name} onChange={(e) => handleArrayChange("oil_details", index, "oil_name", e.target.value)} error={showError} helperText={showError ? submitErrors[`oil_details_${index}`] || submitErrors.checked_danger : ""} />
                    <TextField
                      label="量(L)"
                      value={item.oil_quantity}
                      onChange={handleValidatedDetailChange(
                        "oil_details",
                        index,
                        "oil_quantity",
                        decimalValidator({ scale: 2, label: "量(L)" })
                      )}
                      error={
                        !!errors?.oil_details?.[index]?.oil_quantity ||
                        !!submitErrors[`oil_details_${index}`] ||
                        !!submitErrors.checked_danger
                      }
                      helperText={
                        errors?.oil_details?.[index]?.oil_quantity ||
                        submitErrors[`oil_details_${index}`] ||
                        submitErrors.checked_danger ||
                        ""
                      }
                      onWheel={(e) => e.target.blur()}
                    />
                    {formData.oil_details.length >= 1 && (
                      <IconButton
                        onClick={() => handleDelete("oil_details", index)}
                      >
                        <Delete />
                      </IconButton>
                    )}
                    </Box>
                  )
                })}
                <Button onClick={() => handleAdd("oil_details", { oil_category: "", oil_name: "", oil_quantity: "" })} startIcon={<Add />}>追加</Button>
                {!!changeModalOpen &&(
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={corrections.gas_details}
                        onChange={handleCorrectionChange( 'gas_details')}
                        sx={{
                    color: 'red', // 未チェック時の枠の色
                    '&.Mui-checked': {
                      color: 'red', // チェック時の色
                    },
                  }}
                      />
                    }
                    label="ガス情報"
                  />
                )}
                <Typography variant="subtitle2" gutterBottom>ガス類</Typography>
                {formData.gas_details.map((item, index) => {
                  const showError =
                  !!submitErrors[`gas_details_${index}`] ||
                  (!!submitErrors.checked_danger &&
                    !formData.gas_details.some(
                      i => i.gas_category?.trim() && i.gas_name?.trim() && i.gas_quantity?.trim() && i.gas_number?.trim()
                    )
                  );
                  return (
                    <Box key={index} display="flex" alignItems="center" gap={1} mb={1} className="flex-wrap-sm">
                    <TextField select label="カテゴリ" value={item.gas_category} onChange={(e) => handleGasChange("gas_details", index, "gas_category", e.target.value)} sx={{ width: {xs:'100%',md: '20%'} }} error={showError} helperText={showError ? submitErrors[`gas_details_${index}`] || submitErrors.checked_danger : ""}>
                        <MenuItem value="可燃ガス">可燃性ガス(L.P.Gなど)</MenuItem>
                        <MenuItem value="不燃ガス">不燃性ガス(酸素ガスなど)</MenuItem>
                    </TextField>
                    <TextField label="ガス名" value={item.gas_name} onChange={(e) => handleGasChange("gas_details", index, "gas_name", e.target.value)} error={showError} helperText={showError ? submitErrors[`gas_details_${index}`] || submitErrors.checked_danger : ""} />
                    <TextField
                      label="量(L/1本)"
                      value={item.gas_quantity}
                      onChange={handleValidatedDetailChange(
                        "gas_details",
                        index,
                        "gas_quantity",
                        decimalValidator({ scale: 2, label: "量(L/1本)" })
                      )}
                      error={
                        !!errors?.gas_details?.[index]?.gas_quantity ||
                        !!submitErrors[`gas_details_${index}`] ||
                        !!submitErrors.checked_danger
                      }
                      helperText={
                        errors?.gas_details?.[index]?.gas_quantity ||
                        submitErrors[`gas_details_${index}`] ||
                        submitErrors.checked_danger ||
                        ""
                      }
                      onWheel={(e) => e.target.blur()}
                    />

                    <TextField
                      label="ボンベ(本)"
                      value={item.gas_number}
                      onChange={(e) => handleGasChange("gas_details", index, "gas_number", e.target.value)}  // ← ここを変更
                      error={!!formErrors[`gas_details_${index}_gas_number`] || !!submitErrors[`gas_details_${index}`] || !!submitErrors.checked_danger}
                      helperText={
                        formErrors[`gas_details_${index}_gas_number`] ||
                        submitErrors[`gas_details_${index}`] ||
                        submitErrors.checked_danger ||
                        ""
                      }
                    />

                    <Typography sx={{ width: '15%' }}>
                      合計:{" "}
                      {typeof item.gas_total === "number"
                        ? item.gas_total
                        : Number(item.gas_quantity || 0) * Number(item.gas_number || 0)}{" "}
                      リットル
                    </Typography>
                    {formData.gas_details.length >= 1 && (
                      <IconButton
                        onClick={() => handleDelete("gas_details", index)}
                      >
                        <Delete />
                      </IconButton>
                    )}
                    </Box>
                  )
                })}
                <Button onClick={() => handleAdd("gas_details", {　gas_category: "", gas_name: "", gas_quantity: "", gas_number: "", gas_total: "" })} startIcon={<Add />}>追加</Button>
                {!!changeModalOpen &&(
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={corrections.fire_details}
                        onChange={handleCorrectionChange( 'fire_details')}
                        sx={{
                    color: 'red', // 未チェック時の枠の色
                    '&.Mui-checked': {
                      color: 'red', // チェック時の色
                    },
                  }}
                      />
                    }
                    label="裸火情報"
                  />
                )}
                <Typography variant="subtitle2" gutterBottom>裸火</Typography>
                {formData.fire_details.map((item, index) => {
                  const showError =
                    !!submitErrors[`fire_details_${index}`] ||
                    (!!submitErrors.checked_danger &&
                      !formData.fire_details.some(
                        i => i.fire_device_name?.trim() && i.fire_using?.trim()
                      )
                    );
                  return (
                    <Box key={index} display="flex" alignItems="center" gap={1} mb={1}>
                      <TextField
                        label="機器名"
                        value={item.fire_device_name}
                        onChange={(e) => handleArrayChange("fire_details", index, "fire_device_name", e.target.value)}
                        error={showError}
                        helperText={showError ? submitErrors[`fire_details_${index}`] || submitErrors.checked_danger : ""}
                      />
                      <TextField
                        label="詳細"
                        value={item.fire_using}
                        onChange={(e) => handleArrayChange("fire_details", index, "fire_using", e.target.value)}
                        error={showError}
                        helperText={showError ? submitErrors[`fire_details_${index}`] || submitErrors.checked_danger : ""}
                      />
                      {/* <TextField
                        label="消費熱量(J)"
                        value={item.fire_amount}
                        onChange={handleValidatedDetailChange(
                          "fire_details",
                          index,
                          "fire_amount",
                          decimalValidator({ scale: 2, label: "消費熱量(J)" })
                        )}
                        error={
                          !!errors?.fire_details?.[index]?.fire_amount ||
                          !!submitErrors[`fire_details_${index}`] ||
                          !!submitErrors.checked_danger
                        }
                        helperText={
                          errors?.fire_details?.[index]?.fire_amount ||
                          submitErrors[`fire_details_${index}`] ||
                          submitErrors.checked_danger ||
                          ""
                        }
                        onWheel={(e) => e.target.blur()}
                      /> */}
                      {formData.fire_details.length >= 1 && (
                        <IconButton
                          onClick={() => handleDelete("fire_details", index)}
                        >
                          <Delete />
                        </IconButton>
                      )}
                    </Box>
                  )
                })}
                <Button onClick={() => handleAdd("fire_details", { fire_device_name: "", fire_using: "" })} startIcon={<Add />}>追加</Button>

                {!!changeModalOpen &&(
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={corrections.other_details}
                        onChange={handleCorrectionChange( 'other_details')}
                        sx={{
                    color: 'red', // 未チェック時の枠の色
                    '&.Mui-checked': {
                      color: 'red', // チェック時の色
                    },
                  }}
                      />
                    }
                    label="その他情報"
                  />
                )}
                <Typography variant="subtitle2" gutterBottom>その他</Typography>
                <Typography color="error">※リチウムイオンバッテリー等を持ち込む場合は記載してください。</Typography>
                {formData.other_details.map((item, index) => {
                  return (
                    <Box key={index} display="flex" alignItems="center" gap={1} mb={1}>
                    <TextField label="品名" value={item.other_items} onChange={(e) => handleArrayChange("other_details", index, "other_items", e.target.value)} />
                    <TextField label="詳細" value={item.alfa_text} onChange={(e) => handleArrayChange("other_details", index, "alfa_text", e.target.value)} />
                    {formData.other_details.length >= 1 && (
                      <IconButton
                        onClick={() => handleDelete("other_details", index)}
                      >
                        <Delete />
                      </IconButton>
                    )}
                    </Box>
                  )
                })}
                <Button onClick={() => handleAdd("other_details", { other_items: "", alfa_text: ""})} startIcon={<Add />}>追加</Button>

                <Typography variant="subtitle2" gutterBottom>消火器設備</Typography>
                <TextField fullWidth label="消火器(○○型○○本)" value={formData.extinguisher} onChange={(e) => setFormData({ ...formData, extinguisher: e.target.value })} error={!!submitErrors.extinguisher} helperText={submitErrors.extinguisher} slotProps={{formHelperText: {sx: {color: "#f10a0a",fontWeight: "bold",},},}}/>

                {/* <Typography color="error">「持込有り」で内容が確定していない方は下の「詳細確認中」ボタンをクリックしてください。</Typography>
                <Button variant="contained" onClick={() => handleSubmitEx(exhibitorId)}>詳細確認中</Button> */}
                {/* </>
                )} */}
                {!!changeModalOpen &&(
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={corrections.sdss}
                        onChange={handleCorrectionChange( 'user_4_info')}
                        sx={{
                    color: 'red', // 未チェック時の枠の色
                    '&.Mui-checked': {
                      color: 'red', // チェック時の色
                    },
                  }}
                      />
                    }
                    label="SDS・カタログ等"
                  />
                )}
                <Typography variant="h6" gutterBottom>SDS・カタログアップロード</Typography>
                <input
                    type="file"
                    id="sds-upload"
                    multiple
                    accept=".pdf,.jpg,.jpeg,.png,.webp"
                    onChange={handleFileChange}
                    disabled={uploading}
                />

                <div style={{ marginTop: "1rem" }}>
                  <Typography variant="subtitle2">画像はクリックで拡大できます。</Typography>
                  {previewFiles.length === 0 ? (
                    <p>まずアップロードして下さい。</p>
                  ) : (
                    previewFiles.map((file, idx) => (
                      <div
                        key={idx}
                        style={{ display: "flex", alignItems: "center", gap: "1rem", marginBottom: "0.5rem" }}
                      >
                        {file.previewUrl && file.mimeType?.startsWith("image/") ? (
                          <img
                            key={idx}
                            src={file.previewUrl}
                            alt="preview"
                            onClick={(e) => {
                              e.target.classList.toggle("zoomed");
                            }}
                            style={{
                              width: 100,
                              height: "auto",
                              cursor: "zoom-in",
                              transition: "transform 0.3s ease",
                            }}
                            className="zoom-image"
                          />
                        ) : file.previewUrl && file.mimeType === "application/pdf" ? (
                          <a
                            href={`${baseUrl}/api/get-pdf/${exhibitorId}/${file.name}`}
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            PDFを別タブで開いて確認
                          </a>
                        ) : (
                          <a href={file.previewUrl} target="_blank" rel="noopener noreferrer">
                            {file.safety_path.split("/").pop()}
                          </a>
                        )}
                        {!isCorpModal &&(
                        <IconButton onClick={() => handleDeleteFile(idx)}><Delete /></IconButton>
                        )}
                      </div>
                    ))
                  )}
                </div>
                </Box>
                <Typography variant="h6">備考欄</Typography>
                <Typography color="error">※危険物品について補足事項等がある場合はコチラにご入力ください。</Typography>
                <TextField fullWidth multiline rows={8} label="備考" value={formData.alfa_text} onChange={(e) => setFormData({ ...formData, alfa_text: e.target.value })} />
            </Box>
            </>
            )}
        </Container>
        <Box sx={{border: '1px solid #ccc' , padding: 2, margin: 2, borderRadius: '12px'}}>
          <Typography>
            【上記入力内容についてのお問い合わせ先】<br />
            SDGs 子ども・ユースフェア出展者事務局（中部経済新聞社 事業部内）<br />
            担当：佐野、三宅<br />
            TEL:052-561-5675<br />
            入力フォーム左側の「お問い合わせ」よりお問い合わせください。<br />
            ※お急ぎの場合はお電話にてお問い合わせください。
          </Typography>
        </Box>
        </Container>
      </Container>
      {!isCorpModal &&(
        <>
        <Container sx={{textAlign: 'center'}}>
            <Button variant="contained" color="primary" onClick={() => handleSubmit(exhibitorId)}>
                提出する
            </Button>
        </Container>
        <Dialog open={noticeModalOpen} onClose={handleCloseNotice}>
          <DialogTitle>注意事項</DialogTitle>
          <DialogContent>
            <p>
              危険物品の設置位置を「ブース平面図」よりご提出ください。
            </p>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseNotice} color="primary">
              閉じる
            </Button>
          </DialogActions>
        </Dialog>
      <footer>
        <Typography>
          © 2026 THE MID-JAPAN ECONOMIST.
        </Typography>
       </footer>
       </>
      )}
      {!!changeModalOpen &&(
      <Box display="flex" justifyContent="center" gap={2} mt={2}>
        <Button 
          variant="contained" 
          color="error" 
          onClick={handleCorrection}
          disabled={memoText.trim() === ''}
        >
          修正
        </Button>
        <Button 
          variant="contained" 
          color="primary" 
          onClick={handleConfirm}
        >
          確認
        </Button>
        <Button 
          variant="outlined" 
          onClick={() => setFormModalOpen(false)}
        >
          中断
        </Button>
      </Box>
      )}
    </div>
  );
};

export default Comp11Sub;
